//** industry Api

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
// Axios Imports
import { toast } from 'react-toastify';
import axios from '@src/service/axios';
import { fetchCompanyLogo } from '@src/redux/layout';

export const mockLogin = createAsyncThunk('companySlice/mockLogin', async (id) => {
    try {
        let response = await axios.post('/company-tenant/mock-login/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        // toast.success(response?.data?.message || 'Company Status updated successfully !');
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const getCompany = createAsyncThunk('companySlice/getCompany', async (_,{dispatch}) => {
    try {
        let response = await axios.get('/company-tenant', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getCompanyOption = createAsyncThunk('companySlice/getCompanyOption', async () => {
    try {
        let response = await axios.get('/company-tenant/options', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const createCompany = createAsyncThunk('companySlice/createCompany', async (data, { dispatch }) => {
    try {
        let response = await axios.post('/company-tenant', data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        toast.success(response?.data?.message || 'Company added successfully.');
        dispatch(getCompany());
        dispatch(fetchCompanyLogo());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateCompany = createAsyncThunk('companySlice/updateCompany', async (data, { dispatch }) => {
    try {
        let response = await axios.put('/company-tenant/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        toast.success(response?.data?.message || 'Company updated successfully.');
        await dispatch(getCompany());
        dispatch(fetchCompanyLogo());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateCompanyStatus = createAsyncThunk('companySlice/updateCompanyStatus', async (id, { dispatch }) => {
    try {
        let response = await axios.put('/company-tenant/status/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Company Status updated successfully !');
        dispatch(getCompany());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});



export const deleteCompany = createAsyncThunk('companySlice/deleteCompany', async (deleteId, { dispatch }) => {
    try {
        let response = await axios.delete('/company-tenant/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Company deleted successfully.');
        await dispatch(getCompany());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const companySlice = createSlice({
    name: 'companySlice',
    initialState: {
        data: [],
        option: []
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getCompany.fulfilled, (state, action) => {
            state.data = action.payload;
            return;
        });
        builder.addCase(getCompanyOption.fulfilled, (state, action) => {
            state.option = action.payload;
            return;
        });
    }
});

export default companySlice.reducer;
